
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component({
  components: {}
})
export default class MsgListDiv extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private msgList!: object[];
  @Prop({ default: true }) private isScroll!: boolean;
  @Watch("msgList")
  getVisible() {
    // this.initEchart();
    if (this.isScroll) {
      this.$nextTick(() => {
        this.scroll();
      });
    }
  }
  private divHeight = 0;
  private msgListDiv: objAny = {};
  public scroll() {
    const scrollTop = this.msgListDiv.scrollTop;
    const msgUl: objAny = this.$refs.msgUl;
    const ulHeight = msgUl.offsetHeight;
    const pos = ulHeight - this.divHeight;
    if (pos - scrollTop < this.divHeight) {
      this.msgListDiv.scrollTop = ulHeight;
    }
  }

  mounted() {
    this.$nextTick(() => {
      this.msgListDiv = this.$refs.msgListDiv;
      this.divHeight = this.msgListDiv.offsetHeight;
    });
  }
}
